/**
 * ChargedMesaWarning Modal Component
 * 
 * Displays a warning modal when users attempt to add orders to a mesa
 * that already has a receipt generated. Warns that the receipt will be
 * cancelled and the cancellation will be registered.
 */

import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { FaTriangleExclamation, FaXmark } from 'react-icons/fa6';
import './ChargedMesaWarning.scss';

interface ChargedMesaWarningProps {
  show: boolean;
  onClose: () => void;
  onConfirm: () => void;
  mesaIdentifier?: string | number;
}

const ChargedMesaWarning: React.FC<ChargedMesaWarningProps> = ({
  show,
  onClose,
  onConfirm,
  mesaIdentifier,
}) => {
  return (
    <Modal show={show} onHide={onClose} className="charged-mesa-warning-modal" centered>
      <Modal.Header>
        <div className="warning-header-content">
          <div className="warning-icon-container">
            <FaTriangleExclamation className="warning-icon" />
          </div>
          <Modal.Title className="warning-title">Precuenta Existente</Modal.Title>
        </div>
        <Button variant="none" className="modal-close-button" onClick={onClose}>
          <FaXmark size={20} />
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="warning-body-content">
          <p className="warning-main-text">
            La mesa <strong>{mesaIdentifier || 'seleccionada'}</strong> ya tiene una precuenta generada.
          </p>
          <div className="warning-info-box">
            <p className="warning-info-text">
              Si agregas un nuevo pedido a esta mesa:
            </p>
            <ul className="warning-consequences">
              <li>La precuenta actual será <strong>cancelada automáticamente</strong></li>
              <li>Esta cancelación quedará <strong>registrada en el sistema</strong></li>
              <li>Deberás generar una nueva precuenta con el pedido adicional</li>
            </ul>
          </div>
          <p className="warning-question">
            ¿Deseas continuar y agregar un nuevo pedido?
          </p>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="warning-footer-actions">
          <Button className="warning-button-cancel" variant="none" onClick={onClose}>
            Cancelar
          </Button>
          <Button className="warning-button-confirm" variant="none" onClick={onConfirm}>
            Sí, Agregar Pedido
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChargedMesaWarning;
